import getInstanceAxios from '../../../../services/axiosInstance';
import { variablesGlobales } from '../../../../configs/variables';

export class WompiHelper {

    // Antes le pegaba directo al microservicio de Wompi con el API key en el bundle. Ahora pasa por
    // el app-backend, que valida que el crédito pueda recibir pagos y recién ahí genera el checkout
    // (ver PaymentCtrl.wompiCheckout). Devuelve { reference, signature_integrity } igual que antes;
    // en error devuelve { error: true, code, message } — `code` distingue "crédito aún no habilitado
    // para pagar" (CREDIT_NOT_ENABLED_FOR_PAYMENT) de un fallo técnico.
    async generateCheckout(data = {}) {
        try {
            const axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/payments/wompi/checkout`,
                data
            );
            const jsonData = await responseServer.data;
            return jsonData;
        } catch (error) {
            if (error?.code === "ERR_NETWORK") {
                return {
                    error: true,
                    message: "No se pudo conectar con el servidor.",
                    date: new Date(),
                    code: error.code,
                    status: error?.response?.status
                }
            }
            return {
                error: true,
                message: error.response?.data?.message ?? error.message,
                date: new Date(),
                code: error?.response?.data?.code || error?.code,
                status: error?.response?.status
            }
        }
    }

    convertAmountToCents(amount) {
        let amountInCents = amount * 100;
        return amountInCents;
    }
}
